module.exports = __webpack_public_path__ + "img/jyzt-icon2.1c83729e.png";